import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function TrashIcon() {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/forbid-elements
    _jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      children: [/*#__PURE__*/_jsxs("g", {
        clipPath: "url(#clip0_7168_64149)",
        children: [/*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5 0.00012207C4.44772 0.00012207 4 0.447837 4 1.00012L4 3.00012L1 3.00012L1 5.00012L15 5.00012V3.00012L12 3.00012V1.00012C12 0.447837 11.5523 0.00012207 11 0.00012207L5 0.00012207ZM10 2.00012L6 2.00012L6 3.00012L10 3.00012V2.00012Z",
          fill: "#0661EC"
        }), /*#__PURE__*/_jsx("path", {
          d: "M3 7.00012L13 7.00012V13.0001C13 14.1047 12.1046 15.0001 11 15.0001L5 15.0001C3.89543 15.0001 3 14.1047 3 13.0001L3 7.00012Z",
          fill: "#0661EC"
        })]
      }), /*#__PURE__*/_jsx("defs", {
        children: /*#__PURE__*/_jsx("clipPath", {
          id: "clip0_7168_64149",
          children: /*#__PURE__*/_jsx("rect", {
            width: "16",
            height: "16",
            fill: "white"
          })
        })
      })]
    })
  );
}